import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("spc_token") || sessionStorage.getItem("spc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const path = window.location.pathname;
    if (status === 401) {
      localStorage.removeItem("spc_token");
      localStorage.removeItem("spc_email");
      sessionStorage.removeItem("spc_token");
      sessionStorage.removeItem("spc_email");
      if (path !== "/login" && path !== "/register") window.location.href = "/login";
    } else if (status === 402) {
      if (path !== "/subscribe") window.location.href = "/subscribe";
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}

export default api;
